import React from 'react';
import clsx from 'clsx';
import makeStyles from '@material-ui/core/styles/makeStyles';
import TableOfContent from './TableOfContent';
import {
  ABOUT_ID,
  DIVIDER_COLOR,
  ON_AIR_ID,
  OTETSUTABI_LIST_ID,
  PRIMARY_COLOR,
  SECONDARY_COLOR,
} from '../constants';
import TableFrameImage from '../../../../images/features/local_delivery/table_frame.png';
import TableFrameSpImage from '../../../../images/features/local_delivery/table_frame_sp.png';
import PeopleImage from '../../../../images/features/local_delivery/people.png';
import useMediaQuery from '@material-ui/core/useMediaQuery';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
  },
  peopleImage: {
    position: 'absolute',
    zIndex: 1,
    transform: 'translate(0, -100%)',

    width: 80,
    top: 22,
    left: '15%',
    [theme.breakpoints.up('sm')]: {
      width: 95,
      top: 22,
      left: '20%',
    },
    [theme.breakpoints.up('md')]: {
      width: 110,
      top: 44,
      left: '9%',
    },
  },
  background: {
    position: 'absolute',
    height: '50%',
    width: '100%',
    zIndex: -2,
  },
  backgroundTop: {
    top: 0,
    backgroundColor: SECONDARY_COLOR,
  },
  backgroundBottom: {
    bottom: 0,
    backgroundColor: PRIMARY_COLOR,
  },
  tableFrameContainer: {
    position: 'relative',
    textAlign: 'center',
  },
  tableFrameImage: {
    width: '100%',

    padding: theme.spacing(2),
    maxWidth: 600,
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(4),
      maxWidth: 1244,
    },
  },
  contents: {
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    maxWidth: 1244,
    height: '100%',
    justifyContent: 'space-evenly',

    padding: theme.spacing(4),
    flexDirection: 'column',
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(0, 8),
      flexDirection: 'row',
    },
  },
  divider: {
    maxWidth: 480,

    margin: theme.spacing(0),
    height: 1,
    width: '100%',
    borderBottom: `1px dashed ${DIVIDER_COLOR}`,
    [theme.breakpoints.up('md')]: {
      margin: theme.spacing(2),
      height: 40,
      width: 1,
      borderBottom: 'none',

      borderRight: `1px dashed ${DIVIDER_COLOR}`,
    },
  },
  firstDivider: {
    border: 'none',
    [theme.breakpoints.up('md')]: {
      borderRight: `1px dashed ${DIVIDER_COLOR}`,
    },
  },
}));

const TableOfContents = () => {
  const classes = useStyles();
  const match = useMediaQuery((theme) => theme.breakpoints.up('md'));
  return (
    <div className={classes.root}>
      <img src={PeopleImage} alt="" className={classes.peopleImage} />
      <div className={clsx(classes.background, classes.backgroundTop)} />
      <div className={clsx(classes.background, classes.backgroundBottom)} />
      <div className={classes.tableFrameContainer}>
        <img
          src={match ? TableFrameImage : TableFrameSpImage}
          alt=""
          className={classes.tableFrameImage}
        />
        <div className={classes.contents}>
          <div className={clsx(classes.divider, classes.firstDivider)} />
          <TableOfContent
            id={ABOUT_ID}
            title="WHAT'S OTETSUTABI?"
            subtitle="おてつたびとは？"
          />
          <div className={classes.divider} />
          <TableOfContent
            id={ON_AIR_ID}
            title="ONAIR"
            subtitle="オンエア情報"
          />
          <div className={classes.divider} />
          <TableOfContent
            id={OTETSUTABI_LIST_ID}
            title="OTETSUTABI LIST"
            subtitle="番組で紹介したおてつたび先"
          />
          <div className={classes.divider} />
        </div>
      </div>
    </div>
  );
};

export default TableOfContents;
